import { motion } from "framer-motion";
import React, { useState } from "react";
import {
	FaEnvelope,
	FaGithub,
	FaLinkedinIn,
	FaMapMarkerAlt,
} from "react-icons/fa";
import { useLanguage } from "../context/LanguageContext";

const Contact = () => {
	const { t } = useLanguage();
	const [formStatus, setFormStatus] = useState(null);

	const handleSubmit = (e) => {
		e.preventDefault();
		// Simulate form submission
		setFormStatus("sending");

		setTimeout(() => {
			setFormStatus("success");
			// Reset form
			e.target.reset();
		}, 1500);
	};

	return (
		<section
			id="contact"
			className="py-16 md:py-20 bg-white dark:bg-gray-900 transition-colors duration-300">
			<div className="container mx-auto px-4">
				<motion.div
					className="text-center mb-10 md:mb-16"
					initial={{ opacity: 0, y: 20 }}
					whileInView={{ opacity: 1, y: 0 }}
					viewport={{ once: true }}
					transition={{ duration: 0.5 }}>
					<h2 className="text-2xl md:text-3xl font-bold mb-3 md:mb-4 dark:text-white">
						{t("contactTitle")}
					</h2>
					<p className="text-gray-600 dark:text-gray-400 max-w-lg mx-auto text-sm md:text-base">
						{t("contactSubtitle")}
					</p>
				</motion.div>

				<div className="max-w-4xl mx-auto">
					<div className="flex flex-col md:flex-row gap-8">
						<motion.div
							className="md:w-1/2 mb-8 md:mb-0 md:pr-4 lg:pr-8"
							initial={{ opacity: 0, x: -30 }}
							whileInView={{ opacity: 1, x: 0 }}
							viewport={{ once: true }}
							transition={{ duration: 0.5 }}>
							

							<div className="space-y-4">
								<div className="flex items-center">
									<div className="w-10 h-10 rounded-full bg-blue-100 dark:bg-blue-900 flex items-center justify-center mr-3">
										<FaEnvelope className="text-blue-600 dark:text-blue-400" />
									</div>
									<div>
										<p className="text-xs md:text-sm text-gray-500 dark:text-gray-400">
											Email
										</p>
										<p className="font-medium dark:text-white text-sm md:text-base">
											jpollart@gmail.com
										</p>
									</div>
								</div>

								

								<div className="flex items-center">
									<div className="w-10 h-10 rounded-full bg-blue-100 dark:bg-blue-900 flex items-center justify-center mr-3">
										<FaMapMarkerAlt className="text-blue-600 dark:text-blue-400" />
									</div>
									<div>
										<p className="text-xs md:text-sm text-gray-500 dark:text-gray-400">
											Location
										</p>
										<p className="font-medium dark:text-white text-sm md:text-base">
											Court-Saint-Etienne, Belgium
										</p>
									</div>
								</div>
							</div>

							<div className="mt-8 flex space-x-4">
								<motion.a
									href="https://github.com/zwarmex"
									target="_blank"
									rel="noopener noreferrer"
									whileHover={{ scale: 1.1, y: -3 }}
									className="w-10 h-10 rounded-full bg-gray-900 dark:bg-gray-700 flex items-center justify-center text-white hover:bg-gray-700 dark:hover:bg-gray-600 transition-all shadow-md hover:shadow-lg">
									<FaGithub />
								</motion.a>
								<motion.a
									href="https://www.linkedin.com/in/julien-pollart/"
									target="_blank"
									rel="noopener noreferrer"
									whileHover={{ scale: 1.1, y: -3 }}
									className="w-10 h-10 rounded-full bg-blue-600 flex items-center justify-center text-white hover:bg-blue-700 transition-all shadow-md hover:shadow-lg">
									<FaLinkedinIn />
								</motion.a>
								{/* <motion.a
									href="https://twitter.com/yourusername"
									target="_blank"
									rel="noopener noreferrer"
									whileHover={{ scale: 1.1, y: -3 }}
									className="w-10 h-10 rounded-full bg-blue-400 flex items-center justify-center text-white hover:bg-blue-500 transition-all shadow-md hover:shadow-lg">
									<FaTwitter />
								</motion.a> */}
							</div>
						</motion.div>

						<motion.div
							className="md:w-1/2"
							initial={{ opacity: 0, x: 30 }}
							whileInView={{ opacity: 1, x: 0 }}
							viewport={{ once: true }}
							transition={{ duration: 0.5, delay: 0.2 }}>
							<form
								onSubmit={handleSubmit}
								className="bg-gray-50 dark:bg-gray-800 rounded-lg p-5 md:p-8 shadow-md">
								<div className="mb-4">										<label
										htmlFor="name"
										className="block text-xs md:text-sm font-medium text-gray-700 dark:text-gray-300 mb-1">
										{t("nameLabel")}
									</label>
									<input
										type="text"
										id="name"
										required
										className="w-full px-3 md:px-4 py-2 text-sm md:text-base border border-gray-300 dark:border-gray-600 rounded-md focus:ring-blue-500 focus:border-blue-500 dark:bg-gray-700 dark:text-white"
										placeholder={t("namePlaceholder")}
									/>
								</div>

								<div className="mb-4">
									<label
										htmlFor="email"
										className="block text-xs md:text-sm font-medium text-gray-700 dark:text-gray-300 mb-1">
										{t("emailLabel")}
									</label>
									<input
										type="email"
										id="email"
										required
										className="w-full px-3 md:px-4 py-2 text-sm md:text-base border border-gray-300 dark:border-gray-600 rounded-md focus:ring-blue-500 focus:border-blue-500 dark:bg-gray-700 dark:text-white"
										placeholder={t("emailPlaceholder")}
									/>
								</div>


								<div className="mb-5">
									<label
										htmlFor="message"
										className="block text-xs md:text-sm font-medium text-gray-700 dark:text-gray-300 mb-1">
										{t("messageLabel")}
									</label>
									<textarea
										id="message"
										rows="4"
										required
										className="w-full px-3 md:px-4 py-2 text-sm md:text-base border border-gray-300 dark:border-gray-600 rounded-md focus:ring-blue-500 focus:border-blue-500 dark:bg-gray-700 dark:text-white"
										placeholder={t("messagePlaceholder")}></textarea>
								</div>

								<motion.button
									type="submit"
									whileHover={{ scale: 1.02 }}
									whileTap={{ scale: 0.98 }}
									disabled={formStatus === "sending"}
									className="w-full bg-blue-600 text-white py-2 px-4 rounded-md hover:bg-blue-700 transition-colors focus:outline-none focus:ring-2 focus:ring-blue-500 focus:ring-offset-2 text-sm md:text-base font-medium flex justify-center items-center">
									{formStatus === "sending" ? (
										<>
											<svg
												className="animate-spin -ml-1 mr-2 h-4 w-4 text-white"
												xmlns="http://www.w3.org/2000/svg"
												fill="none"
												viewBox="0 0 24 24">
												<circle
													className="opacity-25"
													cx="12"
													cy="12"
													r="10"
													stroke="currentColor"
													strokeWidth="4"></circle>
												<path
													className="opacity-75"
													fill="currentColor"
													d="M4 12a8 8 0 018-8V0C5.373 0 0 5.373 0 12h4zm2 5.291A7.962 7.962 0 014 12H0c0 3.042 1.135 5.824 3 7.938l3-2.647z"></path>
											</svg>
											{t("contact.sending")}
										</>
									) : formStatus === "success" ? (
										t("contact.messageSent")
									) : (
										t("sendMessage")
									)}
								</motion.button>
							</form>
						</motion.div>
					</div>
				</div>
			</div>
		</section>
	);
};

export default Contact;
